function DetailElement({ title, content }) {
  return (
    <div className="flex flex-col">
      <div className="text-lg font-normal text-gray-400">{title}</div>
      <div className="text-xl font-semibold text-gray-700">{content}</div>
    </div>
  );
}

export default function CarDetails({ car }) {
  return (
    <div>
      <div className="grid grid-cols-2 gap-2">
        {/* <DetailElement title="Tipo:" content={car.type} /> */}
        <DetailElement title="Vestidura:" content={car.skin} />
        <DetailElement title="Transmisión:" content={car.transmission} />
        <DetailElement title="Motor:" content={car.engine} />
        <DetailElement title="Color:" content={car.color} />
        <DetailElement title="Color Interior:" content={car.insideColor} />
      </div>
    </div>
  );
}
